import { defineModel, serializable, castings as castTo } from '../model'

class EventDresscodes {
    @castTo.model('CodeEntry')
    @serializable()
    type: ApiModel<'CodeEntry'>
}

export default defineModel(EventDresscodes)
